import { Sparkles, X } from "lucide-react";

/**
 * Upgrade-Modal das angezeigt wird, wenn das Backend einen strukturierten
 * 429-Fehler mit `code: "MONTHLY_TIER_LIMIT"` zurückgibt.
 *
 * Props:
 *  - open: bool
 *  - detail: { code, module, module_label, tier, limit, used, title, message,
 *              upgrade_to, upgrade_price, upgrade_bullets[] }
 *  - onClose: () => void
 *  - onUpgrade?: () => void  // Standard: navigiert zu /preise
 */
export default function PkiMonatslimitModal({ open, detail, onClose, onUpgrade }) {
  if (!open || !detail) return null;
  const bullets = Array.isArray(detail.upgrade_bullets) ? detail.upgrade_bullets : [];
  const handleUpgrade = () => {
    if (onUpgrade) onUpgrade();
    else window.location.assign("/preise");
  };

  return (
    <div
      data-testid="pki-monatslimit-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="relative w-full max-w-md rounded-2xl border border-cream-300 bg-cream-50 p-6 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          data-testid="pki-monatslimit-close"
          aria-label="Schließen"
          className="absolute right-4 top-4 h-8 w-8 flex items-center justify-center rounded-full text-sand-500 hover:bg-cream-200"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-start gap-3 mb-3">
          <Sparkles className="h-6 w-6 mt-0.5 shrink-0 text-terra" strokeWidth={2} />
          <div>
            <div className="text-[10.5px] uppercase tracking-[0.24em] font-bold text-brand-darkred">
              {detail.title || "Monatslimit erreicht"}
            </div>
            <h2 className="font-display text-[20px] leading-tight mt-1 text-sand-900">
              {detail.module_label || "Modul"} · {detail.used || 0}/{detail.limit || 0} verwendet
            </h2>
          </div>
        </div>

        <p className="text-[13.5px] text-sand-700 leading-snug mb-4">
          {detail.message ||
            "Im Single-Held Tarif sind 10 SIS und 10 Maßnahmenpläne pro Monat enthalten."}
        </p>

        <div className="rounded-xl border border-cream-300 bg-white p-4 mb-5">
          <div className="text-[10.5px] uppercase tracking-[0.22em] font-bold text-sand-500 mb-2">
            Upgrade auf {detail.upgrade_to || "Pflege-KI"}
            {detail.upgrade_price && (
              <span className="ml-2 text-terra font-semibold">{detail.upgrade_price}</span>
            )}
          </div>
          <ul className="space-y-1.5 text-[13px] text-sand-800 leading-snug">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="inline-block mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-terra" />
                <span>✓ {b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleUpgrade}
            data-testid="pki-monatslimit-upgrade"
            className="flex-1 h-11 rounded-full bg-brand-darkred hover:bg-brand-darkred/90 text-white font-semibold text-[13.5px] transition-colors"
          >
            Jetzt upgraden
          </button>
          <button
            type="button"
            onClick={onClose}
            data-testid="pki-monatslimit-spaeter"
            className="h-11 px-5 rounded-full text-sand-700 hover:bg-cream-200 font-medium text-[13px]"
          >
            Später
          </button>
        </div>
      </div>
    </div>
  );
}
